// extracted by mini-css-extract-plugin
export default {"button":"navbar-item_button__N4DZe"};